<script>
    import { getContext } from 'svelte';
    import { Policy, Language } from "@Store";
    import Question from "@components/Question.svelte";
    import { validateMedMal, isAnsweredById, getAnswerText } from "@helpers/validator";
    import { medicalmalpracticeQuestions } from "@helpers/questions";

    const CONTEXT = getContext('CONTEXT');

    // Call the function to get the questions object
    $: questionsList = medicalmalpracticeQuestions($Policy);
    
    $: answered_first_question = isAnsweredById($Policy, questionsList.medical_malpractice_coverage_insurance_limit_question);

    $: needs_medmal = answered_first_question && getAnswerText($Policy, questionsList.medical_malpractice_coverage_insurance_limit_question) !== 'I do not require Clinic Medical Malpractice Coverage';

    function handleAnswer(e) {
        CONTEXT.handleAnswer(e);
    }

    $: valid = validateMedMal($Policy);  

    $: {
        CONTEXT.routeValidation.update(validation => ({
            ...validation,
            medmal: valid
        }));
    }

    
</script>

<div class="page-container">
    {#if questionsList.medical_malpractice_coverage_insurance_limit_question}
        <Question question={questionsList.medical_malpractice_coverage_insurance_limit_question} title={($Language === 'fr') ? "Veuillez sélectionner votre limite d'assurance responsabilité civile médicale pour votre clinique" : 'Please select your clinic medical malpractice limit'} policy={$Policy} on:answered={(e) => handleAnswer(e.detail)} />
    {/if}
    {#if needs_medmal}
        {#if questionsList.please_select_your_abuse_liability_coverage_limits_of_insurance_question}    
            <Question question={questionsList.please_select_your_abuse_liability_coverage_limits_of_insurance_question} required={true} policy={$Policy} on:answered={(e) => handleAnswer(e.detail)} />
        {/if}
        {#if questionsList.is_there_a_written_policy_on_the_prevention_of_abuse_including_sexual_abuse_of_clients_patients_staff_question}
            <Question question={questionsList.is_there_a_written_policy_on_the_prevention_of_abuse_including_sexual_abuse_of_clients_patients_staff_question} required={true} policy={$Policy} on:answered={(e) => handleAnswer(e.detail)} />
        {/if}
        {#if questionsList.does_the_establishment_ensure_that_all_of_its_healthcare_staff_maintain_their_own_malpractice_liability_question}
            <Question question={questionsList.does_the_establishment_ensure_that_all_of_its_healthcare_staff_maintain_their_own_malpractice_liability_question} title={($Language === 'fr') ? "L’établissement veille-t-il à ce que tout son personnel des soins de la santé dispose d’une assurance responsabilité civile professionnelle ?" : 'Does the Establishment ensure that all of its healthcare staff maintain their own malpractice liability coverage?'} required={true} policy={$Policy} on:answered={(e) => handleAnswer(e.detail)} />
        {/if}
        {#if questionsList.as_part_of_the_practitioner_credentialing_process_is_evidence_of_this_coverage_required_on_an_annual_basis_question}
            <Question question={questionsList.as_part_of_the_practitioner_credentialing_process_is_evidence_of_this_coverage_required_on_an_annual_basis_question} required={true} policy={$Policy} on:answered={(e) => handleAnswer(e.detail)} />
        {/if}
        <div class="questions-wrapper">
            <div class="section-container animate__animated animate__fadeInUp">
                <div class="section-header">
                    <div class="section-icon">👩‍⚕️</div>
                    <h1>{($Language === 'fr') ? "Nombre de professionnels de santé:" : 'Number of Health Professional Staff employed:'}</h1>
                </div>
                
                <div class="sub-questions">
                    <div class="sub-question">
                        {#if questionsList.full_time_medical_question}
                            <Question question={questionsList.full_time_medical_question} title={($Language === 'fr') ? "Employés à temps plain" : 'Full-Time'} required={true} policy={$Policy} on:answered={(e) => handleAnswer(e.detail)} />
                        {/if}
                    </div>
                    <div class="sub-question">
                        {#if questionsList.part_time_medical_question}
                            <Question question={questionsList.part_time_medical_question} title={($Language === 'fr') ? "Employés à temps partiel" : 'Part-Time'} required={true} policy={$Policy} on:answered={(e) => handleAnswer(e.detail)} />
                        {/if}
                    </div>
                    <div class="sub-question">  
                        {#if questionsList.contract_medical_question}
                            <Question question={questionsList.contract_medical_question} title={($Language === 'fr') ? "Contractant indépendant" : 'Contractor'} required={true} policy={$Policy} on:answered={(e) => handleAnswer(e.detail)} />
                        {/if}
                    </div>
                </div>
            </div>
        </div>
        <div class="questions-wrapper">
            <div class="section-container animate__animated animate__fadeInUp">
                <div class="section-header">
                    <div class="section-icon">👷‍♂️</div>
                    <h1>{($Language === 'fr') ? "Nombre d’employés qui ne sont pas des professionnels de santé (administratif etc):" : 'Number of Non-Health Personnel employed (administrative, clerical etc.):'}</h1>
                </div>
                <div class="sub-questions">
                    <div class="sub-question">
                        {#if questionsList.full_time_nonmed_question}
                            <Question question={questionsList.full_time_nonmed_question} title={($Language === 'fr') ? "Employés à temps plain" : 'Full-Time'} required={true} policy={$Policy} on:answered={(e) => handleAnswer(e.detail)} />
                        {/if}
                    </div>
                    <div class="sub-question">
                        {#if questionsList.part_time_nonmed_question}
                            <Question question={questionsList.part_time_nonmed_question} title={($Language === 'fr') ? "Employés à temps partiel" : 'Part-Time'} required={true} policy={$Policy} on:answered={(e) => handleAnswer(e.detail)} />
                        {/if}
                    </div>
                    <div class="sub-question">  
                        {#if questionsList.contact_nonmed_question}
                            <Question question={questionsList.contact_nonmed_question} title={($Language === 'fr') ? "Contractant indépendant" : 'Contractor'} required={true} policy={$Policy} on:answered={(e) => handleAnswer(e.detail)} />
                        {/if}
                    </div>
                </div>
            </div>
        </div>
        {#if questionsList.are_the_professional_licenses_or_certificates_of_all_employees_and_independent_contractors_verified_prior_to_their_employment_question}
            <Question question={questionsList.are_the_professional_licenses_or_certificates_of_all_employees_and_independent_contractors_verified_prior_to_their_employment_question} required={true} policy={$Policy} on:answered={(e) => handleAnswer(e.detail)} />
        {/if}
        {#if questionsList.is_informed_consent_obtained_prior_to_all_medical_procedures_treatments_tests_etc_question}
            <Question question={questionsList.is_informed_consent_obtained_prior_to_all_medical_procedures_treatments_tests_etc_question} required={true} policy={$Policy} on:answered={(e) => handleAnswer(e.detail)} />
        {/if}
        {#if questionsList.do_you_provide_any_services_to_any_pro_semi_pro_or_carded_athletes_question}
            <Question question={questionsList.do_you_provide_any_services_to_any_pro_semi_pro_or_carded_athletes_question} required={true} policy={$Policy} on:answered={(e) => handleAnswer(e.detail)} />
        {/if}
        {#if questionsList.do_you_follow_the_current_guidance_for_infection_prevention_control_issued_by_the_public_health_agency_of_canada_or_provincial_health_agency_ie_ipac_sharps_safe_collection_storage_and_disposal_of_hazardous_waste_etc_question}
            <Question question={questionsList.do_you_follow_the_current_guidance_for_infection_prevention_control_issued_by_the_public_health_agency_of_canada_or_provincial_health_agency_ie_ipac_sharps_safe_collection_storage_and_disposal_of_hazardous_waste_etc_question} required={true} policy={$Policy} on:answered={(e) => handleAnswer(e.detail)} />
        {/if}
        {#if questionsList.is_the_clinic_currently_participating_in_any_clinical_trials_question}
            <Question question={questionsList.is_the_clinic_currently_participating_in_any_clinical_trials_question} required={true} policy={$Policy} on:answered={(e) => handleAnswer(e.detail)} />
        {/if}
    {/if}
</div>